// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields} = state;

	if (fields.radio_customer_personal_info.checked) {
		return true;
	}

	return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/GDPR/GDPR.fulfillment.js